import { enumController } from '@/apis/core';
import {
  ADD_ENUM_VERTICAL_TYPE,
  ADD_ENUM_RCS_USE_CASE,
  ADD_ENUM_10DLC_USE_CASE,
} from './index';

export const getVerticalTypes = () => async (dispatch, getState) => {
  const { shareReducer } = getState();
  if (shareReducer.enums?.verticalTypes?.length > 0) {
    return;
  }
  const verticalTypes = await enumController.getVerticalTypes();
  dispatch({
    type: ADD_ENUM_VERTICAL_TYPE,
    payload: verticalTypes,
  });
};

export const getRcsUseCases = () => async (dispatch, getState) => {
  const { shareReducer } = getState();
  if (shareReducer.enums?.rcsUseCases?.length > 0) {
    return;
  }
  const useCases = await enumController.getUsecaseTypes({
    channelId: 'RCS',
  });
  dispatch({
    type: ADD_ENUM_RCS_USE_CASE,
    payload: useCases,
  });
};

export const getTenDlcUseCases = () => async (dispatch, getState) => {
  const { shareReducer } = getState();
  if (shareReducer.enums?.tenDlcUseCases?.length > 0) {
    return;
  }
  const useCases = await enumController.getUsecaseTypes({
    channelId: '10DLC',
  });
  dispatch({
    type: ADD_ENUM_10DLC_USE_CASE,
    payload: useCases,
  });
};
